module.exports = __webpack_public_path__ + "img/DSC_0051-compressor_tn.748e3fc5.jpg";